import isError from 'lodash/isError';
import { isFfmpegError, isFfprobeError } from '../transcoding/ffmpeg';
import { Logger } from '../types/logger';
import { exceptionToString } from './exception';

export function exceptionToUserFriendlyMessage(
  logger: Logger,
  ex: unknown,
): string {
  logger.error(exceptionToString(ex));
  if (isFfmpegError(ex)) {
    if (ex.errorMessage !== undefined) {
      return ex.errorMessage;
    }
    return ex.toString();
  }

  if (isFfprobeError(ex)) {
    if (ex.errorMessage !== undefined) {
      return ex.errorMessage;
    }
    return ex.toString();
  }

  if (isError(ex)) {
    return ex.message;
  }

  return exceptionToString(ex);
}
